import { Application, BasePlugin, URLParams } from '@goodboydigital/astro';

import { App } from '../App';

export class LocationPlugin implements BasePlugin
{
    public app: App;
    private _countryId!: string;

    constructor(app: Application)
    {
        this.app = app as App;
        this._getIpCountryCode();
    }

    /**
     * Fetch user's country location using Turner's Geo IP API
     * @returns
     */
    private async _getIpCountryCode(): Promise<void>
    {
        const debugCountry = URLParams.get('country');

        if (debugCountry)
        {
            console.log('[LocationPlugin] Forced Location:', debugCountry);
            this._countryId = debugCountry as string;

            return;
        }

        console.log('[LocationPlugin] Getting IP info...');

        try
        {
            const response = await fetch('https://geoip.turner-apps.com/api/get_geoip_data');
            const data = await response.json();

            this._countryId = data.country;
            console.log('[LocationPlugin] Location is:', data.country);
        }
        catch (e)
        {
            this._countryId = 'GB';
            console.error('[LocationPlugin] Cannot retrieve IP address!');
        }
    }

    get countryId(): string
    {
        return this._countryId;
    }
}
